import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  organizations: [],
  currentOrganization: null,
  stats: {},
  loading: false,
  error: null,
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 0,
  },
}

const organizationSlice = createSlice({
  name: 'organization',
  initialState,
  reducers: {
    setOrganizations: (state, action) => {
      state.organizations = action.payload
    },
    setCurrentOrganization: (state, action) => {
      state.currentOrganization = action.payload
    },
    setStats: (state, action) => {
      state.stats = action.payload
    },
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
    },
    setPagination: (state, action) => {
      state.pagination = { ...state.pagination, ...action.payload }
    },
    addOrganization: (state, action) => {
      state.organizations.unshift(action.payload)
    },
    updateOrganization: (state, action) => {
      const index = state.organizations.findIndex(org => org.id === action.payload.id)
      if (index !== -1) {
        state.organizations[index] = action.payload
      }
    },
    deleteOrganization: (state, action) => {
      state.organizations = state.organizations.filter(org => org.id !== action.payload)
    },
    clearOrganizationData: (state) => {
      state.organizations = []
      state.currentOrganization = null
      state.stats = {}
    },
  },
})

export const {
  setOrganizations,
  setCurrentOrganization,
  setStats,
  setLoading,
  setError,
  setPagination,
  addOrganization,
  updateOrganization,
  deleteOrganization,
  clearOrganizationData,
} = organizationSlice.actions

export default organizationSlice.reducer